import './card-score.scss';

export default () => {

};
